<template>
  <b-card>
    <h3>Report for the year : {{ year }}</h3>
    <b-form-group label="Filter by Month:" label-cols-sm="6" label-align-sm="right" label-size="sm">
      <b-form-select v-model="selectedMonth" :options="monthFilterOptions" @change="filterByMonth" size="sm" />
    </b-form-group>
    <b-table responsive :items="filteredSalesData" :fields="fields" class="mb-0">
      <template #cell(salesAmount)="data">
        {{ data.item.salesAmount.toFixed(2) }}
      </template>
      <template #cell(revenueAmount)="data">
        {{ data.item.revenueAmount.toFixed(2) }}
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { BTable, BCard, BFormSelect, BFormGroup } from "bootstrap-vue";

export default {
  components: {
    BTable,
    BCard,
    BFormSelect,
    BFormGroup,
  },
  props: {
    sales: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      year: new Date().getFullYear(),
      selectedMonth: null,
      monthFilterOptions: [
        { value: null, text: "All Months" },
        { value: 0, text: "January" },
        { value: 1, text: "February" },
        { value: 2, text: "March" },
        { value: 3, text: "April" },
        { value: 4, text: "May" },
        { value: 5, text: "June" },
        { value: 6, text: "July" },
        { value: 7, text: "August" },
        { value: 8, text: "September" },
        { value: 9, text: "October" },
        { value: 10, text: "November" },
        { value: 11, text: "December" },
      ],
      fields: [
        { key: "month", label: "Month" },
        { key: "salesQuantity", label: "Sales Quantity" },
        { key: "salesAmount", label: "Sales Amount" },
        { key: "revenueAmount", label: "Revenue Amount" },
      ],
      salesData: [],
      filteredSalesData: [],
    };
  },
  methods: {
    calculateSalesData(sales) {
      let monthlyData = {};

      sales.forEach((order) => {
        let monthIndex = new Date(order.issuedDate).getMonth();

        if (!monthlyData[monthIndex]) {
          monthlyData[monthIndex] = {
            monthIndex, // Store numeric month index for filtering
            month: this.getMonthName(monthIndex),
            salesQuantity: 0,
            salesAmount: 0,
            revenueAmount: 0,
          };
        }

        order.orderItems.forEach((item) => {
          monthlyData[monthIndex].salesQuantity += item.qty;
          monthlyData[monthIndex].salesAmount += item.qty * item.price;
        });

        monthlyData[monthIndex].revenueAmount += order.total;
      });

      return Object.values(monthlyData);
    },
    getMonthName(monthIndex) {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return monthNames[monthIndex];
    },
    filterByMonth() {
      if (this.selectedMonth === null) {
        this.filteredSalesData = this.salesData; // Show all data if no month is selected
      } else {
        this.filteredSalesData = this.salesData.filter(
          (data) => data.monthIndex === this.selectedMonth
        );
      }
    },
  },
  watch: {
    sales: {
      immediate: true,
      handler(newSales) {
        this.salesData = this.calculateSalesData(newSales);
        this.filteredSalesData = [...this.salesData]; // Initialize with full data
      },
    },
  },
};
</script>
